const {gql} = require('graphql-tag')
export default gql`
  mutation createArtworks ($input: ArtworkInputs!) {
    createArtworks (input: $input) {
      id
    }
  }
`
